import { useMutation } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig } from '@/lib/react-query';
import { RemoteCommandType } from '@/types/remoteControlcommad';

export const postRemoteCommandInspection =
  (makeRequest: any) =>
  async ({
    shipmentId,
    lpui,
    command,
    ticketId,
  }: {
    shipmentId: string;
    lpui: string;
    command: RemoteCommandType;
    ticketId: string;
  }): Promise<any> => {
    const { error, data } = await makeRequest({
      path: `/inspection/tickets/${ticketId}/products/${lpui}/remote-commands`,
      method: 'post',
      body: {
        shipment_id: shipmentId,
        type: command,
      },
    });
    if (error) {
      throw new Error(error.response.data.message);
    }

    return data;
  };
type UsePostRemoteCommandInspectionOptions = {
  config?: MutationConfig<ReturnType<typeof postRemoteCommandInspection>>;
};
export const usePostRemoteCommandInspection = ({
  config,
}: UsePostRemoteCommandInspectionOptions) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useMutation({
    ...config,
    mutationFn: postRemoteCommandInspection(makeRequest),
  });
};
